var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var Permissions = /** @class */ (function () {
    function Permissions() {
    }
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    Permissions.PermissionsPrefix = 'Permissions';
    Permissions.Clients = (_a = /** @class */ (function () {
            function class_1() {
            }
            return class_1;
        }()),
        __setFunctionName(_a, "Clients"),
        _a.GroupName = 'Clients',
        _a.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_a.GroupName, "."),
        _a.Read = "".concat(_a.PermissionPrefix, "Read"),
        _a.Update = "".concat(_a.PermissionPrefix, "Update"),
        _a.Create = "".concat(_a.PermissionPrefix, "Create"),
        _a.Delete = "".concat(_a.PermissionPrefix, "Delete"),
        _a);
    Permissions.Machines = (_b = /** @class */ (function () {
            function class_2() {
            }
            return class_2;
        }()),
        __setFunctionName(_b, "Machines"),
        _b.GroupName = 'Assets',
        _b.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_b.GroupName, "."),
        _b.Read = "".concat(_b.PermissionPrefix, "Read"),
        _b.Update = "".concat(_b.PermissionPrefix, "Update"),
        _b.Create = "".concat(_b.PermissionPrefix, "Create"),
        _b.Delete = "".concat(_b.PermissionPrefix, "Delete"),
        _b);
    Permissions.Knowledge = (_c = /** @class */ (function () {
            function class_3() {
            }
            return class_3;
        }()),
        __setFunctionName(_c, "Knowledge"),
        _c.GroupName = 'Knowledge',
        _c.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_c.GroupName, "."),
        _c.Read = "".concat(_c.PermissionPrefix, "Read"),
        _c.Update = "".concat(_c.PermissionPrefix, "Update"),
        _c.Create = "".concat(_c.PermissionPrefix, "Create"),
        _c.Delete = "".concat(_c.PermissionPrefix, "Delete"),
        _c);
    Permissions.Roles = (_d = /** @class */ (function () {
            function class_4() {
            }
            return class_4;
        }()),
        __setFunctionName(_d, "Roles"),
        _d.GroupName = 'Roles',
        _d.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_d.GroupName, "."),
        _d.Read = "".concat(_d.PermissionPrefix, "Read"),
        _d.Update = "".concat(_d.PermissionPrefix, "Update"),
        _d.Create = "".concat(_d.PermissionPrefix, "Create"),
        _d.Delete = "".concat(_d.PermissionPrefix, "Delete"),
        _d);
    Permissions.Users = (_e = /** @class */ (function () {
            function class_5() {
            }
            return class_5;
        }()),
        __setFunctionName(_e, "Users"),
        _e.GroupName = 'Users',
        _e.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_e.GroupName, "."),
        _e.Read = "".concat(_e.PermissionPrefix, "Read"),
        _e.Update = "".concat(_e.PermissionPrefix, "Update"),
        _e.Create = "".concat(_e.PermissionPrefix, "Create"),
        _e.Delete = "".concat(_e.PermissionPrefix, "Delete"),
        _e);
    Permissions.Technicians = (_f = /** @class */ (function () {
            function class_6() {
            }
            return class_6;
        }()),
        __setFunctionName(_f, "Technicians"),
        _f.GroupName = 'Technicians',
        _f.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_f.GroupName, "."),
        _f.Read = "".concat(_f.PermissionPrefix, "Read"),
        _f.Update = "".concat(_f.PermissionPrefix, "Update"),
        _f);
    Permissions.Companies = (_g = /** @class */ (function () {
            function class_7() {
            }
            return class_7;
        }()),
        __setFunctionName(_g, "Companies"),
        _g.GroupName = 'Companies',
        _g.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_g.GroupName, "."),
        _g.Read = "".concat(_g.PermissionPrefix, "Read"),
        _g.Update = "".concat(_g.PermissionPrefix, "Update"),
        _g.Create = "".concat(_g.PermissionPrefix, "Create"),
        _g.Delete = "".concat(_g.PermissionPrefix, "Delete"),
        _g);
    Permissions.Settings = (_h = /** @class */ (function () {
            function class_8() {
            }
            return class_8;
        }()),
        __setFunctionName(_h, "Settings"),
        _h.GroupName = 'Settings',
        _h.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_h.GroupName, "."),
        _h.Read = "".concat(_h.PermissionPrefix, "Read"),
        _h.Update = "".concat(_h.PermissionPrefix, "Update"),
        _h.Create = "".concat(_h.PermissionPrefix, "Create"),
        _h.Delete = "".concat(_h.PermissionPrefix, "Delete"),
        _h);
    Permissions.Training = (_j = /** @class */ (function () {
            function class_9() {
            }
            return class_9;
        }()),
        __setFunctionName(_j, "Training"),
        _j.GroupName = 'Training',
        _j.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_j.GroupName, "."),
        _j.Read = "".concat(_j.PermissionPrefix, "Read"),
        _j.Update = "".concat(_j.PermissionPrefix, "Update"),
        _j.Delete = "".concat(_j.PermissionPrefix, "Delete"),
        _j);
    Permissions.Audit = (_k = /** @class */ (function () {
            function class_10() {
            }
            return class_10;
        }()),
        __setFunctionName(_k, "Audit"),
        _k.GroupName = 'Audit',
        _k.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_k.GroupName, "."),
        _k.Read = "".concat(_k.PermissionPrefix, "Read"),
        _k);
    Permissions.Faqs = (_l = /** @class */ (function () {
            function class_11() {
            }
            return class_11;
        }()),
        __setFunctionName(_l, "Faqs"),
        _l.GroupName = 'Faqs',
        _l.PermissionPrefix = "".concat(Permissions.PermissionsPrefix, ".").concat(_l.GroupName, "."),
        _l.Read = "".concat(_l.PermissionPrefix, "Read"),
        _l.Update = "".concat(_l.PermissionPrefix, "Update"),
        _l.Create = "".concat(_l.PermissionPrefix, "Create"),
        _l.Delete = "".concat(_l.PermissionPrefix, "Delete"),
        _l);
    return Permissions;
}());
export { Permissions };
